import Header from '../components/Header';
import Products from '../components/Products';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const ProductsPage = () => {
  return (
    <>
      <Header />
      <div style={{marginTop: '64px'}}>
        <Products />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default ProductsPage;
